import React from "react";
import PreferencesNav from "./PreferencesNav";
import { Toaster, toast } from "react-hot-toast";
import { useEffect } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { callGetAxios, callPostAxios } from "../../services/common/common";
import { CUSTOMER_CATEGORY_URL, SUB_CATEGORY_URL, VENDOR_CATEGORY_URL } from "../../CONSTANTS";
import Loader from "../Common/Loader";
import { CUSTOM_CATEGORY_COMPONENT_TYPE } from "../utils/utilsConstants";

const { CUSTOMER_CATEGORY, VENDOR_CATEGORY, SUB_CATEGORY } = CUSTOM_CATEGORY_COMPONENT_TYPE

const getComponentData = {
    [CUSTOMER_CATEGORY]: {
        title: "Customer Category List",
        allCatUrl: CUSTOMER_CATEGORY_URL() + "getKeyValueList",
        addNewCatUrl: CUSTOMER_CATEGORY_URL()
    },
    [VENDOR_CATEGORY]: {
        title: "Vendor Category List",
        allCatUrl: VENDOR_CATEGORY_URL() + "getKeyValueList",
        addNewCatUrl: VENDOR_CATEGORY_URL()

    },
    [SUB_CATEGORY]: {
        title: "Item Sub Category List",
        allCatUrl: SUB_CATEGORY_URL() + "getKeyValueList",
        addNewCatUrl: SUB_CATEGORY_URL()
    },
}


const CustomCategory = ({ parentFlag }) => {
    const [isPending, setIsPending] = useState(false);

    const [categoryList, setCategoryList] = useState(null);
    const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
    const [categoryTitle, setCategoryTitle] = useState("");

    useEffect(() => {
        getCategoryList();
    }, [parentFlag]);

    const getCategoryList = async () => {
        try {
            setIsPending(true)
            const rUrl = getComponentData[parentFlag].allCatUrl
            const res = await callGetAxios(rUrl)
            if (res.errorCode == 0) {
                setCategoryList(res.responsePacket);
            }
            setIsPending(false)
        } catch (error) {
            setIsPending(false)
            console.error(error)
        }
    };


    const handleSave = async () => {
        if (!categoryTitle && categoryTitle === "") {
            toast("Please Provide Category Name");
            return;
        }

        const rUrl = getComponentData[parentFlag].addNewCatUrl
        const rObj = {
            title: categoryTitle,
        };
        const res = await callPostAxios(rUrl, rObj)
        if (res.errorCode == 0) {
            toast(res.message);
            getCategoryList();
            setShowAddCategoryModal(false);
            setCategoryTitle("");
        } else {
            toast(res.message);
        }
    };


    if (isPending) {
        return <Loader />
    }

    return (
        <>
            {/* <div className="column list-column d-print-none column-small">
                <PreferencesNav />
            </div> */}
            <div className="column content-column">
                <div className="header clearfix" style={{ borderBottom: "none" }}>
                    <span className="float-left" style={{ fontSize: "35px" }}>
                        {getComponentData[parentFlag].title}
                    </span>
                </div>

                <div className="text-right mt-5 mr-4">
                    <button className="btn btn-primary mt-4" type="button" onClick={() => setShowAddCategoryModal(true)}>
                        <AddIcon />
                        New
                    </button>
                </div>
                <div className="m-4 p-3 border">
                    <Table striped className="customTable">
                        <tbody>
                            {categoryList &&
                                categoryList.map((category, key) => (
                                    <tr key={key}>
                                        <td>{category.value}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </div>
            </div>
            <Modal show={showAddCategoryModal} onHide={() => setShowAddCategoryModal(false)} size="sm">
                <Modal.Header>Add New</Modal.Header>
                <Modal.Body>
                    <table>
                        <tr>
                            <td>Title:</td>
                            <td>
                                <input autoComplete="off" className=" form-control" value={categoryTitle} name="title" onChange={(e) => setCategoryTitle(e.target.value)} />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
            <Toaster />
        </>
    );
};

export default CustomCategory;
